module.exports = __webpack_public_path__ + "media/bootstrap-icons/stickies-fill-08b4ebe2.svg";